<template lang="pug">
main.main(:style="{'--main-height': height}")
  section.section.columns.light.top#top
    .txt.column.is-6
      img.logo.is-desktop(src="@/assets/img/icon/logo.png")
      img.logo.is-tablet(src="@/assets/img/icon/logo-mobile.png")
      //- img.subtitle.is-mobile(src="@/assets/img/icon/subtitle-mobile.png")
      
  section.section.light.about#about
    h2.title About
    .video-container
      vue-plyr.plyr
        video(controls crossorigin playsinline data-poster='@/assets/img/movie2.png')
          source(size='1080' src='@/assets/wi-monitor_202103161453.mp4' type='video/mp4')
          source(size='1080' src='@/assets/wi-monitor_202103161453.webm' type='video/webm')

  section.section.concept#concept
    h2.title Concept
    .columns
      .card-container.columns.column
        .card.column(v-for='(c, index) in concepts' :key='index')
          .card-content
            .content
              img.icon(:src='c.icon')
              p {{ c.name }}
              //- p {{ c.text }}
      .description.column
        p.bold Wi-Monitor is a brand new system to measure occupancy of areas. It uses only Wi-Fi to recognize the number of people in the room. The number of people can be checked online.
        p Now camera is widely used to detect congestion, which is questioned for its invasion of privacy. Wi-Monitor is a privacy conscious system. It only uses the amount of change of Wi-Fi signals between transmitter and receiver.
        p Wi-Monitor can easily show the number of people in the room to real time, while camera needs huge amount of computing resource to do so.
        p You only need to stick this on the wall to measure the occupancy. Wi-Monitor is a small device. it is 6 × 3 × 2 cm . It sends data to cloud, and the results are shown on webpage. <br/> 
          span *You need to teach it the number of people for about 30 minutes.
  section.section.live#live
    h2.title Live
    .columns.iframe-container
      iframe(width="1080" height="520" src="https://app.wimonitorsxsw.com/" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
    .columns.icon
      a(href="https://app.wimonitorsxsw.com/" target="_blank" rel="noopener noreferrer" )
        img(src="@/assets/img/icon/open_in_new-24px.svg")
  section.section.light.point#point
    h3.title Advantages
    .card-container.columns
      .card.column.is-one-third
        .card-image
          figure.image
            img(src='@/assets/img/camera.jpg')
        .card-content
          .content
            h3 Camera
            p
              i.fas.fa-times
              | Need to place where the whole area can see.
            p
              i.fas.fa-times
              | Useless under dim lights
      .card.column.is-one-third
        .card-image
          figure.image
            img(src='@/assets/img/radio.jpg')
        .card-content
          .content
            h3 Beacon
            p
              i.fas.fa-times
              | Expensive
            p
              i.fas.fa-times
              | Measure only those who have smartphones
      .card.column.is-one-third
        .card-image
          figure.image
            img(src='@/assets/img/wifi.jpg')
        .card-content
          .content
            .ours
              h3 Wi-Fi
              span Ours
            p
              i.far.fa-circle
              | Privacy conscious
            p
              i.far.fa-circle
              | Real-time monitoring with normal computing resources.
  section.section.light.method#method
    h2.title Method
    .columns
      figure.image.column
        img(src='@/assets/img/method.png')
      .description.column Wi-Fi have a property of reflecting on water. Water makes up 80% of human body. This leads to the fact that human body reflects Wi-Fi. Therefore, by linking the amount of change in Wi-Fi signals between transmitter and receiver and the number of people through machine learning, you can detect the number of people.
  section.section.light.member#member
    h2.title Member
    .container
      .card-container.columns
        .card.column.is-one-third(v-for='m in members' :key="m.name")
          .card-header
            p.card-header-title {{ m.job }}
          .card-image
            figure.image
              img(:src='m.src')
          .card-content
            .content
              h3.name {{ m.name }}
      .description.column We are colleagues in a laboratory, 
        | <a target="_blank" rel="noopener noreferrer" href="http://webpark5033.sakura.ne.jp/wp/">Koshizuka Lab</a> , in the University of Tokyo. <br/>
        | The research theme of this lab is social implementation of Artificial Intelligence and IoT.
      
  section.section.light.gallery#gallery
    h2.title Gallery
    .container
      vue-picture-swipe(:items="items")
  section.section.contact#contact
    .columns
      a.column.contact__button(target="_blank" rel="noopener noreferrer" href="https://forms.gle/xcP1QNavcV9hsz7b8")
        span CONTACT
  Footer
</template>

<script>
import Footer from '../components/Footer.vue'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

export default {
  name: 'Page',
  components: {
    Footer,
    VuePlyr
  },
  data() {
    return {
      items: [{
          src: require('@/assets/img/gallery/DSC04023.jpg'),
          thumbnail: require('@/assets/img/thumbnail/DSC04023.jpg'),
          w: 1440,
          h: 960,
          alt: 'some numbers on a grey background' // optional alt attribute for thumbnail image
        },
        {
          src: require('@/assets/img/gallery/DSC04034.jpg'),
          thumbnail: require('@/assets/img/thumbnail/DSC04034.jpg'),
          w: 1440,
          h: 960,
          alt: 'some numbers on a grey background' // optional alt attribute for thumbnail image
        },
        {
          src: require('@/assets/img/gallery/DSC04035.jpg'),
          thumbnail: require('@/assets/img/thumbnail/DSC04035.jpg'),
          w: 1440,
          h: 960,
          alt: 'some numbers on a grey background' // optional alt attribute for thumbnail image
        },
        {
          src: require('@/assets/img/gallery/DSC04039.jpg'),
          thumbnail: require('@/assets/img/thumbnail/DSC04039.jpg'),
          w: 1440,
          h: 960,
          alt: 'some numbers on a grey background' // optional alt attribute for thumbnail image
        },
        {
          src: require('@/assets/img/gallery/DSC04043.jpg'),
          thumbnail: require('@/assets/img/thumbnail/DSC04043.jpg'),
          w: 1440,
          h: 960,
          alt: 'some numbers on a grey background' // optional alt attribute for thumbnail image
        },
        {
          src: require('@/assets/img/gallery/DSC04044.jpg'),
          thumbnail: require('@/assets/img/thumbnail/DSC04044.jpg'),
          w: 1440,
          h: 960,
          alt: 'some numbers on a grey background' // optional alt attribute for thumbnail image
        },
        {
          src: require('@/assets/img/gallery/DSC04048.jpg'),
          thumbnail: require('@/assets/img/thumbnail/DSC04048.jpg'),
          w: 1440,
          h: 960,
          alt: 'some numbers on a grey background' // optional alt attribute for thumbnail image
        }
      ],
      concepts: [
        {
          name: "Privacy Conscious",
          icon: require('@/assets/img/icon/lock.svg')

        },
        {
          name: "Real-time Monitoring",
          icon: require('@/assets/img/icon/time.svg')
        },
        {
          name: "Easy to set up",
          icon: require('@/assets/img/icon/settings.svg')
        }
      ],
      members: [
        {
          name: 'Takekazu Kitagishi',
          job: 'Engineer',
          src: require('@/assets/img/kitagishi.jpg'),
          affiliation: 'Koshizuka Lab',
          detail: ['Public health', 'Computer Science']
        },
        {
          name: 'Yusuke Sasaki',
          job: 'Data Scientist',
          src: require('@/assets/img/sasaki.jpg'),
          affiliation: 'Koshizuka Lab',
          detail: ['Comedian in Japan', 'Data Science']
        },
        {
          name: 'Masahiro Matsui',
          job: 'Engineer',
          src: require('@/assets/img/matsui.jpg'),
          affiliation: 'Koshizuka Lab',
          detail: ['Worked at google for intern']
        }
      ],
      height: 0
    }
  },
  handleResize: function() {
    this.height = window.innerHeight + 'px'
  },
  mounted() {
    this.height = window.innerHeight + 'px'
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped lang="stylus">
.main
  height 100vh
  scroll-snap-type y proximity
  overflow-y scroll
  -ms-overflow-style none
  scrollbar-width none
  &::-webkit-scrollbar
    display none
  section.section
    background-color bg-color
    width 100%
    min-height 100%
    padding 48px 120px 48px nav-width
    text-align center
    font-size 1.2em
    margin 0
    overflow-y scroll
    scroll-snap-align start
    -ms-overflow-style none
    scrollbar-width none
    &::-webkit-scrollbar
      display none
    .title
      text-align right
      padding-bottom 24px
      font-weight 300
      position relative
      color text-color
      font-size 60px
      margin-bottom 0
    &.light
      background-color bg2-color
      color main-color
      .title
        color main-color
    
    &.top
      center-align()
      background-image url("~@/assets/img/main-vis.jpg")
      background-repeat no-repeat
      background-size cover
      background-position center center
      justify-content flex-start
      .txt
        img
          max-width 360px
          min-width 200px
          width 80%
          margin 0 auto
        .subtitle
          display none
    &.about
      .title
        padding-bottom 36px
      .video-container
        width 80%
        min-width main-width
        max-width content-width
        margin 0 auto

    &.concept
      & > .columns
        width 100%
        max-width content-width
        margin 0 auto
      .card-container
        flex-direction column
        max-width 420px
        .card.column
          center-align()
          overflow initial
          background-color middle-color
          color main-color
          font-weight bold
          border-radius radius-size 0 radius-size 0
          box-shadow 0 0.3em 1em -0.125em rgba(0, 0, 0, .5)
          margin 16px 8px
          .card-content
            padding 1.5rem
          .icon
            width 3.6rem
            height 3.6rem
    .description
      text-align justify
      padding 0 0 0 48px
      .bold
        text-align left
        font-weight 900
        font-size 1.4em
        line-height 1.4em
        letter-spacing .05em
      p
        line-height 1.6em
        padding 16px 0
        span 
          font-size .8em
    &.live
      .columns
        width 80%
        min-width main-width
        max-width content-width
        center-align()
        margin 16px auto 0
        iframe
          min-height 400px
          max-width 100%
    &.point
      .card-container.columns
        .card.column
          padding 0
          border-radius radius-size 0 radius-size 0
          margin 24px 16px
          .card-content
            .content
              h3
                margin .6em auto .3em
                font-weight 900
              .ours
                position relative
                span
                  position absolute
                  top -26px
                  left 50%
                  transform translateX(-50%)
                  color text-color
                  font-size 14px
                  font-weight bold
                  letter-spacing .08em
                  background-color middle-color
                  display inline-block
                  padding 1px 8px
              p
                margin-bottom 0
                svg
                  margin-right 8px
                .fa-times
                  color #F80002
                .fa-circle
                  color middle-color
          &:nth-child(1)
            transform translateY(24px)
          &:nth-child(2)
            transform translateY(48px)
          &:nth-child(3)
            transform translateY(-8px)
    &.method
      & > .columns
        width 100%
        max-width content-width
        margin 0 auto
        center-align()
      figure
        max-width 420px
        img
          margin 16px 0
          width 100%
          height auto
    &.member
      .container
        center-align()
        flex-direction column
        .description
          padding 0
      .card-container.columns
        display flex
        justify-content center
        align-items normal
        .card.column
          align-items center
          padding 0
          border-radius radius-size 0 radius-size 0
          margin 24px 16px
          max-width 'calc((%s - 32px) / 3)' % content-width
          .card-header
            box-shadow none
            .card-header-title
              display block
              writing-mode vertical-rl
              position absolute
              top 0
              right 0
              letter-spacing .08em
              padding 8px 8px 16px 0
              font-size .8em
              width 40px
              color text-color
              background-color middle-color
          .card-image
            padding-right 36px
          .card-content
            padding  1em
    &.gallery
      title
        padding-bottom 36px
      .container
        width 100%
        max-width content-width
        margin 0 auto
        center-align()

            
    &.contact
      center-align()
      min-height calc(100% - 96px)
      flex-direction column
      .contact__button
        width 400px
        max-width 80%
        padding 16px 40px
        margin 8px auto
        display block
        border-radius radius-size 0 radius-size 0
        background-color main-color
        transition all .4s
        border 1px solid text-color
        outline none
        span
            transition all .4s
            letter-spacing .1em
            font-weight 400
            color text-color
        &:hover
            background-color middle-color
            span
                letter-spacing .15em
      a.mail
        display inline-block
        margin 0 8px
        color text-color
        font-size 1.2em
        &:hover
          opacity .8
  .card
      margin 24px 8px

.point .card-container, .member .container
  margin 0 80px
.about iframe, .concept > .columns, .method > .columns, .gallery .container
  margin 0 0 0 24px

.is-desktop
  display block
.is-mobile
  display none
.is-tablet
  display none

+tb()
  .is-desktop
    display none
  .is-tablet
    display block
  .main
    padding-left 0
    min-height 100vh
    height var(--main-height)
    min-height -webkit-fill-available
    scroll-snap-type none
    section.section
      padding 0 32px 32px
      font-size 1em
      scroll-snap-align none
      .description
        font-size 22px
        padding 24px
      .title
        font-size 3.2em
        text-align left
        padding-top "calc(%s + 8px)" % nav-height
      &.top
        flex-direction column
        text-align left
        margin 0
        max-height 100vh
        padding 0
        background-image url("~@/assets/img/main-vis-tablet.jpg")
        .txt
          img
            max-width initial
            min-width 300px
            padding-top nav-height
            width 100%
        & > figure
          margin 0 auto
          padding 0
      &.about .video-container
        width 100%
        min-width initial
        max-width 100%
      &.concept
        & > .columns
          flex-direction column
          max-width 100%
        .card-container
          flex-direction row
          display flex
          width 100%
          max-width initial
          margin 0
          padding 0
          .card.column
            &:nth-child(1)
              margin-left 0
            &:nth-child(3)
              margin-right 0
            .card-content
              padding .5rem 1.5rem
              font-size 20px
              .no
                top 40px
                left 12px
                &::after
                  width 40px
                  height 40px
      .description
        padding 0
        .bold
          line-height 1.2em
        p
          padding 8px 0
          line-height 1.4em
      &.live .columns
        width 100%
        min-width initial
        max-width 100%
        iframe
          max-height 30vmin
      &.point
        .card-container.columns
          display block
          .card.column
            margin 16px 0
            width 100%
            display flex
            .card-image .image
              width 35vmin
              height 100%
              img
                height 100%
                object-fit cover
            .card-content
              padding 1rem
              .content
                text-align left
                font-size 22px
                .ours
                  span
                    top 50%
                    transform translateY(-50%)
            &:nth-child(1), &:nth-child(2), &:nth-child(3)
              transform none
      &.method .columns
        flex-direction column
        padding 0 16px
        figure img
          max-height 60vmin
          width auto
      &.member
        .container
          margin 0
          .card-container.columns
            margin 8px auto
            .card.column
              margin 8px
              width calc((100% - 32px) / 3 )
              .card-header
                .card-header-title
                  writing-mode initial
                  position relative
                  padding 8px
                  width 100%
                  font-size 14px
              .card-image
                padding 0
              .card-content
                padding 8px 12px
                h3
                  font-size 20px
                  font-size 1.4em
                  margin-bottom 8px
      &.contact
        .columns
          width 100%
        .contact__button
          span
            font-size 20px
      &.point .card-container, &.member .container
        margin 0
      &.about iframe, &.concept > .columns, &.method > .columns, &.gallery .container
        margin 0

+sp()
  .is-desktop
    display none
  .is-mobile
    display block
  .main
    section.section
      padding 0 16px 32px
      .title
        padding-bottom 8px
        font-size 2.2em
      .description
        font-size 16px
        padding 8px 0
      &.top
        background-image url("~@/assets/img/main-vis-mobile.jpg")
      &.concept .card-container
        .card.column
          max-width calc((100% - 16px) / 3 ) 
          margin 4px 4px 8px
          .card-content
            padding 0
            font-size 16px
            p
              line-height 1.2em
          .icon
            width 3rem
            height 3rem
      &.live .columns iframe
        max-height initial
        min-height initial
        height 240px
      &.point .card-container.columns .card.column .card-content .content
        h3
          font-size 20px
          margin 0
        p 
          font-size 16px
          line-height 1.4em
      &.method .columns
        padding 0
        figure
          padding 0
          img
            max-height 70vmin
      &.member
        .container
          margin 0
          .card-container.columns
            margin 8px auto
            .card.column
              margin 0 8px
              width calc((100% - 32px) / 3 )
              &:nth-child(1), &:nth-child(3)
                margin 0
      &.member .container .card-container.columns .card.column
        .card-header .card-header-title
          font-size 12px
        .card-content h3
          font-size 20px
</style>
